import * as React from 'react';
import { Button, TextField } from '../common';
import { BaseDialog, BaseDialogProps, BaseDialogState } from '../common/dialog/BaseDialog';
import { Grid2 as Grid } from '@mui/material';
import { UserTitleRole } from '../../enums';
import { UserTitleRoleSelect } from './UserTitleRoleSelect';

interface Props extends BaseDialogProps {
    readonly onCreate: (username: string, role: UserTitleRole) => void;
}

interface State extends BaseDialogState {
    readonly username: string;
    readonly role: UserTitleRole;
}

export class AddUserTitleDialog extends BaseDialog<Props, State> {
    state = this.initState();

    protected renderContent(): React.JSX.Element {
        const { username, role } = this.state;

        return (
            <Grid container={true} spacing={0}>
                <Grid size={12}>
                    <TextField
                        label="Email address"
                        fullWidth={true}
                        value={username}
                        required={true}
                        onChange={this.updateUsername}
                        variant="outlined"
                    />
                </Grid>
                <Grid size={12}>
                    <UserTitleRoleSelect
                        label="Role"
                        role={role}
                        updateRole={this.updateRole}
                    />
                </Grid>
            </Grid>
        );
    }

    protected renderActions(): React.JSX.Element {
        return (
            <Button text="Create" onClick={this.onCreate} variant="contained" disabled={!this.validate()} />
        );
    }

    protected initState(): State {
        return {
            username: '',
            role: UserTitleRole.Viewer,
        };
    }

    private validate() {
        const { username, role } = this.state;
        if (username === '') {
            return false;
        }
        return role !== UserTitleRole.NoRole;

    }

    private updateUsername = (username: string) => this.setState({ username });

    private updateRole = (role: UserTitleRole) => this.setState({ role });

    private onCreate = () => {
        const { username, role } = this.state;
        if (!this.validate()) {
            return;
        }
        this.props.onCreate(username, role);
        this.onClose();
    };
}
